import React from "react";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../../../API/exercise";
import PageRadio from "../PageRadio";
import PageCheckBox from "../PageCheckBox";
import PageJudge from "../PageJudge";
import PageSubjective from "../PageSubjective";
import PageGapFilling from "../PageGapFilling";

interface PageRadioProps {
    data: TopicsItem;
    oneSave: (questionId: string, value: string) => void;
    moreSave: (questionId: string, value: any) => void;
    oneChange: (questionId: string, value: string) => void;
    moreChange: (questionId: string, value: any) => void;
}

export default function PageReading({
    data,
    oneSave,
    moreSave,
    oneChange,
    moreChange
}: PageRadioProps) {
    return (
        <div className={style.root}>
            <div className={style.top}>
                <span className={style.index}>{data.index}. </span>
                <span className={style.score}>
                    （{data.typeName}，{data.score}分）
                </span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
            </div>
            {data.questions.map((item, index) => {
                return (
                    <div key={index} className={style.subStyle}>
                        {item.queTypeId.toString() === "1" && (
                            <PageRadio
                                data={item}
                                oneSave={oneSave}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "2" && (
                            <PageCheckBox
                                data={item}
                                moreSave={moreSave}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "3" && (
                            <PageJudge
                                data={item}
                                oneSave={oneSave}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "4" && (
                            <PageSubjective
                                data={item}
                                oneSave={oneSave}
                                oneChange={oneChange}
                                index={index + 1}
                            />
                        )}
                        {item.queTypeId.toString() === "5" && (
                            <PageGapFilling
                                data={item}
                                moreSave={moreSave}
                                moreChange={moreChange}
                                index={index + 1}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
